import { useState, useEffect } from 'react';

import { Stack, Button } from '@mui/material';

/* hooks */

import { useNavigateParams } from '../../../hooks/useNavigateParams';

import Input from '../../form/Input';
import Checkbox from '../../form/Checkbox';

function Form({ token, dados, setDados, empresaId, empresaIds, parametro, handleSubmit, btnText, caminhoVoltar }) {
    const navigate = useNavigateParams();

    function handleChange(e) {
        if (e.target.name === 'ativo' || e.target.name === 'administrativo') {
            setDados({ ...dados, [e.target.name]: e.target.checked });
        } else {
            setDados({ ...dados, [e.target.name]: e.target.value });
        }
    }
    async function handleOnBlur(e) {}
    function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();
        handleSubmit(dados);
    };

    return (
        <form onSubmit={submit}>
            <h1>Gestão de Menus</h1>
            <div>
                <Input
                    text="Menu"
                    type="text"
                    name="descricao"
                    placeholder="nome do Menu"
                    title="Digite o nome do Menu"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.descricao || ''}
                    required
                />
                <Input
                    text="Título"
                    type="text"
                    name="title"
                    placeholder="Título"
                    title="Digite o título que aparecerá quando o mouse estiver no menu"
                    inputWidth="350px"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.title || ''}
                />
            </div>
            <div>
                <Checkbox
                    title="Quando marcado informa que o menu é do modulo da administração,
                    funciona para empresa que o Parâmetro tabelas comuns estiver desmarcado."
                    text="Administrativo"
                    name="administrativo"
                    handleOnChange={handleChange}
                    value={dados.administrativo}
                    checked={!!dados.administrativo}
                />
                <Checkbox
                    title="Quando marcado o menu esta ATIVO"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={handleChange}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />
            </div>
            <div>
                <Stack direction="row" spacing={1}>
                    <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                        Voltar
                    </Button>
                    <Button type="submit" variant="contained" color="success">
                        {btnText}
                    </Button>
                </Stack>
            </div>
        </form>
    );
}

export default Form;
